module.exports = __webpack_public_path__ + "static/img/webLogo.1b4ca55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webLogo.png
// module id = Ffcd
// module chunks = 1